export * from './page-header/page-header.module';
export * from './stat/stat.module';



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/modules/index.ts